let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bF67x")).then(() => parcelRequire('8YOXj'));